import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VPannellum from 'vue-pannellum';   // 全局引入vue-pannellum
Vue.component('VPannellum', VPannellum);    // // 全局配置Vpannellum



// 全局初始化 webviewBridge
// eslint-disable-next-line no-unused-vars
import webviewBridge from './services/webviewBridge';

Vue.config.productionTip = false

// iOS 微信中，需要记录第一次进入页面的 URL 用于签名
// 必须在应用启动时就记录，因为用户可能从任何页面进入
if (!window.entryUrl) {
  window.entryUrl = window.location.href.split('#')[0];
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')